import {MODES, DESTINATIONS, CSS_CLASS_NAMES as CSS} from '../settings/constants';

// This is the monster HTML template...
export function getTemplate ($t) {
  let template = `
    <div class="lbs-dialog-header" title="">
        <h2>${$t('snapshot-settings')}</h2>
        <button class="lbs-dialog-close-button"></button>
    </div>
    <div class="lbs-dialog-body">
        <div class="lbs-vertical-tab-container">
            <div class="tab-button-container">
                <label class="tab-button">
                    <input type="radio" name="tab-button" checked />
                    <span>
                        <span>${$t('image-settings')}</span>
                        <span class="icon image-settings-icon"></span>
                    </span>
                </label>
                <label class="tab-button">
                    <input type="radio" name="tab-button" />
                    <span>
                        <span>${$t('advanced-settings')}</span>
                        <span class="icon advanced-settings-icon"></span>
                    </span>
                </label>
            </div>
            <div class="tab-content-container">
                <div class="tab-content snapshot-image-settings">
                    <div class="image-settings-upper mode-selection-container">
                        <label class="lbs-select-container">
                            <span>${$t('select-mode')}:</span>
                            <select class="snapshot-mode-options" name="mode">
                                <option value="${MODES.WYSIWYG}">${$t('full-view')}</option>
                                <option value="${MODES.FIXED}">${$t('fixed-size')}</option>
                                <option value="${MODES.RESIZABLE}">${$t('resizable')}</option>
<!-- N/A for 12.4
                                <option value="${MODES.FIXED_ASPECT}">$\{i18n['fixed-aspect']}</option>
-->
                            </select>
                        </label>
                    </div>`;

  template += `<div class="image-settings-lower">
                        <div class="mode-settings-container">
                            <b>
                                <span class="mode-name"></span>
                            </b>
                            <div class="${CSS.SIZE_OPTIONS}">
                                <label>
                                    <span>${$t('width')}:</span>
                                    <input name="width" type="text" class="lbs-form-control" />
                                    <span>${$t('px')}</span>
                                </label>
                                <label>
                                    <span>${$t('height')}:</span>
                                    <input name="height" type="text" class="lbs-form-control" />
                                    <span>${$t('px')}</span>
                                </label>
                            </div>
                        </div>
                        <div class="big-red-button-container">
                            <button class="the-big-red-button">${$t('capture')}</button>
                        </div>
                    </div>
                </div>
                <div class="tab-content snapshot-advanced-settings">
                    <dl>
                        <dt>${$t('save-to')}:</dt>
                        <dd class="${CSS.DESTINATION_BUTTONS} lbs-form-group">
                            <label>
                                <input class="lbs-form-control" type="radio" name="destination" value="${DESTINATIONS.CLIENT}" />
                                <span title="${$t('local-description')}">${$t('local')}</span>
                            </label>
                            <label>
                                <input class="lbs-form-control" type="radio" name="destination" value="${DESTINATIONS.SERVER}" />
                                <span title="${$t('remote-description')}">${$t('remote')}</span>
                            </label>
                        </dd>
                    </dl>
                </div>
            </div>
        </div>
    </div>
    <div class="lbs-dialog-footer">
        <div class="snapshot-settings-message-container">
            <b>${$t('description')}:</b>
            <div class="snapshot-settings-message"></div>
        </div>
    </div>
`;
  return template;
}



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/snapshot/tool/MainUi.html.js